import styled from 'styled-components'
import { colors } from '../../../assets/colors'

const Text = styled.span`
  color: ${colors.black};
  font-size: 14px;
`

export default Text
